import React, { useEffect, useState, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { baseURL } from "../../util/Config";
import { warning } from "../../util/Alert";
import noImage from "../../assets/images/noImage.png";
import $ from "jquery";
import SvipDialog from "../dialog/SvipDialog";
import { OPEN_DIALOGUE_SVIP } from "../../store/Svip/type";
import {
  deleteSvip,
  getSVIPS,
  deleteSvipField,
  updateSvip,
} from "../../store/Svip/action";
import SVGA from "svgaplayerweb";

const Svip = (props) => {
  const { svips } = useSelector((state) => state.svip);
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [selectedSvip, setSelectedSvip] = useState(null);

  useEffect(() => {
    dispatch(getSVIPS());
  }, [dispatch]);

  useEffect(() => {
    setData(svips);
  }, [svips]);

  const handleDelete = (id) => {
    warning().then((ok) => {
      if (ok) {
        props.deleteSvip(id);
      }
    });
  };

  const handleOpen = () => {
    dispatch({ type: OPEN_DIALOGUE_SVIP });
  };

  const handleEdit = (data) => {
    dispatch({ type: OPEN_DIALOGUE_SVIP, payload: data });
  };

  const handleDeleteField = (id, field) => {
    const confirm = window.confirm(`Delete ${field}?`);

    if (!confirm) return;

    props
      .deleteSvipField(id, field)
      .then((res) => {
        if (res?.data?.status) {
          setSelectedSvip(null); // ✅ CLOSE MODAL
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Replace one asset: the backend matches the field by keyword in the filename
  const handleReplaceField = (id, keyword, file) => {
    const ext = file.name.includes(".") ? file.name.slice(file.name.lastIndexOf(".")) : "";
    const formData = new FormData();
    formData.append("files", new File([file], keyword + ext, { type: file.type }));

    props
      .updateSvip(id, formData)
      .then((res) => {
        if (res?.data?.status) setSelectedSvip(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const assets = [
    { title: "Badge", field: "badge", keyword: "badge" },
    { title: "Frame", field: "frame", keyword: "frame" },
    { title: "Border", field: "borderFinal", keyword: "border" },
    { title: "Msg Box", field: "msgBox", keyword: "msg" },
    { title: "Profile Card", field: "profileCard", keyword: "profile" },
    { title: "Room Background", field: "roomBg", keyword: "room" },
    { title: "Entry Effect", field: "entryEffect", keyword: "entry" },
    { title: "Name Plate", field: "vipNamePlate", keyword: "name" },
  ];

  return (
    <>
      {/* HEADER */}
      <div className="page-title">
        <h3 className="text-white">SVIP</h3>
      </div>

      <div className="main-wrapper">
        {/* NEW BUTTON */}
        <button className="btn btn-danger btn-sm mb-3" onClick={handleOpen}>
          <i className="fa fa-plus"></i> New
        </button>

        {/* LIST */}
        <div className="row mt-4">
          {data?.length > 0 ? (
            data.map((item) => (
              <div className="col-md-4 mb-4" key={item._id}>
                <div className="card p-3 text-center position-relative">
                  {/* ACTIONS */}
                  <div
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      display: "flex",
                      gap: 10,
                    }}
                  >
                    <i
                      className="fas fa-edit text-primary"
                      style={{ cursor: "pointer", fontSize: 18 }}
                      onClick={() => handleEdit(item)}
                    />
                    <i
                      className="fas fa-trash text-danger"
                      style={{ cursor: "pointer", fontSize: 18 }}
                      onClick={() => handleDelete(item._id)}
                    />
                  </div>

                  {/* NAME */}
                  <h5 className="text-white mb-3">{item?.name}</h5>

                  {/* BADGE PREVIEW */}
                  <img
                    src={item?.badge ? baseURL + item.badge : noImage}
                    alt="badge"
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />

                  {/* VIEW BUTTON */}
                  <button
                    className="btn btn-light btn-sm mt-3"
                    onClick={() => setSelectedSvip(item)}
                  >
                    <i className="fas fa-eye me-1"></i> View
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-white">Nothing to show</p>
          )}
        </div>
      </div>

      <SvipDialog />

      {/* ================= MODAL ================= */}
      {selectedSvip && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "85%",
              background: "#1a1a1a",
              borderRadius: 10,
              padding: 20,
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            {/* HEADER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <h4 className="text-white">
                {selectedSvip?.name || "SVIP Details"}
              </h4>

              <button
                className="btn btn-danger btn-sm"
                onClick={() => setSelectedSvip(null)}
              >
                Close ✖
              </button>
            </div>

            {/* GRID */}
            <div className="row text-center">
              {assets.map((a) => (
                <AssetBox
                  key={a.field}
                  title={a.title}
                  file={selectedSvip?.[a.field]}
                  onDelete={() => handleDeleteField(selectedSvip._id, a.field)}
                  onReplace={(file) =>
                    handleReplaceField(selectedSvip._id, a.keyword, file)
                  }
                />
              ))}

              {/* ACTIONS */}
              <div className="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-center gap-2">
                <p className="text-white mb-1">
                  <i className="fas fa-gem me-1"></i>
                  {selectedSvip?.diamond} · {selectedSvip?.validity}{" "}
                  {selectedSvip?.validityType}
                </p>
                <button
                  className="btn btn-primary btn-sm"
                  style={{ width: 160 }}
                  onClick={() => {
                    const item = selectedSvip;
                    setSelectedSvip(null);
                    handleEdit(item);
                  }}
                >
                  <i className="fas fa-edit me-1"></i> Edit Details
                </button>
                <button
                  className="btn btn-outline-danger btn-sm"
                  style={{ width: 160 }}
                  onClick={() => {
                    const id = selectedSvip._id;
                    setSelectedSvip(null);
                    handleDelete(id);
                  }}
                >
                  <i className="fas fa-trash me-1"></i> Delete SVIP
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

/* ================= ASSET BOX ================= */
const AssetBox = ({ title, file, onDelete, onReplace }) => {
  const ref = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (file && file.endsWith(".svga") && ref.current) {
      const player = new SVGA.Player(ref.current);
      const parser = new SVGA.Parser(ref.current);

      parser.load(baseURL + file, (videoItem) => {
        player.setVideoItem(videoItem);
        player.startAnimation();
      });
    }
  }, [file]);

  return (
    <div className="col-md-4 mb-4 text-center" style={{ position: "relative" }}>
      {/* TITLE */}
      <h6 className="text-white">{title}</h6>

      {/* EDIT / DELETE ICONS */}
      <div
        style={{
          position: "absolute",
          top: 10,
          right: 25,
          display: "flex",
          gap: 12,
        }}
      >
        <i
          className="fas fa-edit text-primary"
          title={file ? `Replace ${title}` : `Upload ${title}`}
          onClick={() => inputRef.current?.click()}
          style={{ cursor: "pointer" }}
        />
        {file && (
          <i
            className="fas fa-trash text-danger"
            title={`Delete ${title}`}
            onClick={onDelete}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept=".svga,image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const picked = e.target.files?.[0];
          e.target.value = "";
          if (picked) onReplace(picked);
        }}
      />

      {/* CONTENT */}
      {!file ? (
        <p style={{ color: "orange" }}>No data available</p>
      ) : file.endsWith(".svga") ? (
        <div ref={ref} style={{ width: 120, height: 120, margin: "auto" }} />
      ) : (
        <img
          src={baseURL + file}
          alt={title}
          style={{ width: 120, height: 120 }}
          onError={(e) => (e.target.src = noImage)}
        />
      )}
    </div>
  );
};

export default connect(null, {
  getSVIPS,
  deleteSvip,
  deleteSvipField,
  updateSvip,
})(Svip);
